var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { Component } from "@theme/component";
import { oncePerEditorSession } from "@theme/utilities";
class ComparisonSliderComponent extends Component {
  constructor() {
    super();
    __publicField(this, "requiredRefs", ["mediaWrapper", "slider", "afterImage"]);
    this.hasAnimated = false;
    this.boundHandleIntersection = this.handleIntersection.bind(this);
  }
  /**
   * Called when component is added to DOM
   */
  connectedCallback() {
    super.connectedCallback();
    const { mediaWrapper } = this.refs;
    this.orientation = mediaWrapper.dataset.orientation || "horizontal";
    this.sync();
    this.setupIntersectionObserver();
  }
  /**
   * Sync the CSS custom property with the input value
   */
  sync() {
    const { mediaWrapper, slider } = this.refs;
    if (this.isAnimating) return;
    const val = (Number(slider.value) - Number(slider.min)) / (Number(slider.max) - Number(slider.min));
    const compareValue = Math.round(val * 100);
    mediaWrapper.style.setProperty("--compare", String(compareValue));
  }
  /**
   * Clean up when component is removed
   */
  disconnectedCallback() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
  }
  /**
   * Set the slider value and update display
   * @param {number} value - Value between 0-100 (0 = all after, 100 = all before)
   */
  setValue(value) {
    const { slider } = this.refs;
    if (!slider) return;
    slider.value = String(value);
    this.sync();
  }
  /**
   * Animate the slider handle to give users a hint about the interaction
   */
  animateSlider() {
    const { mediaWrapper, slider } = this.refs;
    if (this.hasAnimated) return;
    this.hasAnimated = true;
    this.isAnimating = true;
    mediaWrapper.style.setProperty("--transition-duration", "0.5s");
    setTimeout(() => {
      mediaWrapper.style.setProperty("--compare", "40");
    }, 100);
    setTimeout(() => {
      mediaWrapper.style.setProperty("--compare", "60");
    }, 600);
    setTimeout(() => {
      mediaWrapper.style.setProperty("--compare", "50");
    }, 1100);
    setTimeout(() => {
      mediaWrapper.style.setProperty("--transition-duration", "0s");
      slider.value = "50";
      this.isAnimating = false;
    }, 1600);
  }
  /**
   * Set up intersection observer to detect when section comes into view
   */
  setupIntersectionObserver() {
    if (!window.IntersectionObserver) return;
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5
      // Trigger when 50% of the component is visible
    };
    this.intersectionObserver = new IntersectionObserver(this.boundHandleIntersection, options);
    this.intersectionObserver.observe(this);
  }
  /**
   * Handle intersection observer callback
   * @param {IntersectionObserverEntry[]} entries
   */
  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !this.hasAnimated) {
        setTimeout(() => {
          oncePerEditorSession(this, `comparison-slider-animated`, () => {
            this.animateSlider();
          });
        }, 300);
        if (this.intersectionObserver) {
          this.intersectionObserver.disconnect();
        }
      }
    });
  }
}
if (!customElements.get("comparison-slider-component")) {
  customElements.define("comparison-slider-component", ComparisonSliderComponent);
}
export {
  ComparisonSliderComponent
};
